import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClassificationIndex from './pages/Classification/Index';
import Categories from './pages/Classification/Categories';
import Subcategories from './pages/Classification/Subcategories';
import Families from './pages/Classification/Families';
import Hierarchy from './pages/Classification/Hierarchy';
import ClasificacionServiciosLayout from './pages/Classification/Services/ClasificacionServiciosLayout';
import ServicesCategories from './pages/Classification/Services/Categories';
import ServicesSubcategories from './pages/Classification/Services/Subcategories';
import ServicesFamilies from './pages/Classification/Services/Families';
import ServicesHierarchy from './pages/Classification/Services/Hierarchy';
import Products from './pages/Products/Index';
import CreateProduct from './pages/Products/Create';
import EditProduct from './pages/Products/Edit';
import Services from './pages/Services/Index';
import CreateService from './pages/Services/Create';
import EditService from './pages/Services/Edit';
import PurchaseOrders from './pages/PurchaseOrders/Index';
import RequirementsIndex from './pages/Requirements/Index';
import CreateRequirement from './pages/Requirements/Create';
import EditRequirement from './pages/Requirements/Edit';
import PrintRequirement from './pages/Requirements/Print';
import CreatePurchaseOrder from './pages/PurchaseOrders/Create';
import EditPurchaseOrder from './pages/PurchaseOrders/Edit';
import PrintPurchaseOrder from './pages/PurchaseOrders/Print';
import ServiceOrders from './pages/ServiceOrders/Index';
import CreateServiceOrder from './pages/ServiceOrders/Create';
import EditServiceOrder from './pages/ServiceOrders/Edit';
import PrintServiceOrder from './pages/ServiceOrders/Print';
import ContinuousServices from './pages/ContinuousServices/Index';
import CreateContinuousService from './pages/ContinuousServices/Create';
import ContinuousServiceDetail from './pages/ContinuousServices/Detail';
import Configuration from './pages/Configuration/Index';
import Units from './pages/Configuration/Units';
import Conversions from './pages/Configuration/Conversions';
import Attributes from './pages/Configuration/Attributes';
import Warehouses from './pages/Configuration/Warehouses';
import Projects from './pages/Configuration/Projects';
import PointOfSales from './pages/Configuration/PointOfSales';
import Areas from './pages/Configuration/Areas';
import Milestones from './pages/Configuration/Milestones';
import DocumentNumberSeries from './pages/Configuration/DocumentNumberSeries';
import Suppliers from './pages/Suppliers/Index';
import CreateSupplier from './pages/Suppliers/Create';
import EditSupplier from './pages/Suppliers/Edit';
import Entities from './pages/Entities/Index';
import CreateEntity from './pages/Entities/Create';
import EditEntity from './pages/Entities/Edit';
import SunatMappings from './pages/SunatMappings/Index';
import Documents from './pages/Documents/Index';
import CreateDocument from './pages/Documents/Create';
import EditDocument from './pages/Documents/Edit';
import PrintDocument from './pages/Documents/Print';
import PrintContinuousService from './pages/ContinuousServices/Print';
import SelectWarehouse from './pages/Warehouses/Select';
import WarehouseDocuments from './pages/Warehouses/Documents';
import CreateEntryGuide from './pages/EntryGuides/Create';
import EditEntryGuide from './pages/EntryGuides/Edit';
import CreateInitialGuide from './pages/InitialGuides/Create';
import EditInitialGuide from './pages/InitialGuides/Edit';
import CreateExitGuide from './pages/ExitGuides/Create';
import EditExitGuide from './pages/ExitGuides/Edit';
import CreateTransferGuide from './pages/TransferGuides/Create';
import EditTransferGuide from './pages/TransferGuides/Edit';
import CreateReceptionGuide from './pages/ReceptionGuides/Create';
import EditReceptionGuide from './pages/ReceptionGuides/Edit';
import CreateAdjustmentGuide from './pages/AdjustmentGuides/Create';
import EditAdjustmentGuide from './pages/AdjustmentGuides/Edit';
import PrintEntryGuide from './pages/EntryGuides/Print';
import PrintInitialGuide from './pages/InitialGuides/Print';
import PrintExitGuide from './pages/ExitGuides/Print';
import PrintTransferGuide from './pages/TransferGuides/Print';
import PrintReceptionGuide from './pages/ReceptionGuides/Print';
import Kardex from './pages/Reports/Kardex';
import KardexDetail from './pages/Reports/KardexDetail';
import KardexRecalculate from './pages/Reports/KardexRecalculate';
import KardexInconsistencies from './pages/Reports/KardexInconsistencies';
import KardexAudit from './pages/Audit/KardexAudit';
import AuditNotificationRecipients from './pages/Audit/AuditNotificationRecipients';
import AuditRulesSettings from './pages/Audit/AuditRulesSettings';
import AuditInventoryCount from './pages/Audit/AuditInventoryCount';
import AuditMyInventoryCounts from './pages/Audit/AuditMyInventoryCounts';
import KardexAuditGuard from './components/Audit/KardexAuditGuard';
import WarehouseInventoryCount from './pages/Warehouses/InventoryCount';
import EntriesExits from './pages/Reports/EntriesExits';
import EntriesExitsMatrix from './pages/Reports/EntriesExitsMatrix';
import ExitsBySupplier from './pages/Reports/ExitsBySupplier';
import DocumentTraceability from './pages/Administration/DocumentTraceability';
import PurchaseOrderTraceability from './pages/Administration/PurchaseOrderTraceability';
import ServiceOrderTraceability from './pages/Administration/ServiceOrderTraceability';
import EntryGuideTraceability from './pages/Administration/EntryGuideTraceability';
import RequirementTraceability from './pages/Administration/RequirementTraceability';
import ModuleSettings from './pages/Administration/ModuleSettings';
import IntegrationSettings from './pages/Administration/IntegrationSettings';
import GeneralSettings from './pages/Administration/GeneralSettings';
import { ModuleSettingsProvider, useModuleSettings } from './contexts/ModuleSettingsContext';
import Machines from './pages/Machinery/Machines/Index';
import CreateMachine from './pages/Machinery/Machines/Create';
import EditMachine from './pages/Machinery/Machines/Edit';
import Vehicles from './pages/Machinery/Vehicles/Index';
import CreateVehicle from './pages/Machinery/Vehicles/Create';
import VehicleComplianceAlerts from './pages/Machinery/Vehicles/ComplianceAlerts';
import EditVehicle from './pages/Machinery/Vehicles/Edit';
import Maintenance from './pages/Machinery/Maintenance/Index';
import MaintenanceHistory from './pages/Machinery/Maintenance/History';
import EventsOverview from './pages/Machinery/Events/Overview';
import Events from './pages/Machinery/Events/Index';
import CreateEvent from './pages/Machinery/Events/Create';
import EditEvent from './pages/Machinery/Events/Edit';
import EventTypesConfig from './pages/Machinery/EventTypes/Index';
import MachineryReports from './pages/Machinery/Reports/Index';
import MachineryCategories from './pages/Machinery/Categories/Index';
import Conductors from './pages/Machinery/Conductors/Index';
import CreateConductor from './pages/Machinery/Conductors/Create';
import EditConductor from './pages/Machinery/Conductors/Edit';
import HourMeters from './pages/Machinery/HourMeters/Index';
import CreateHourMeter from './pages/Machinery/HourMeters/Create';
import Kilometers from './pages/Machinery/Kilometers/Index';
import CreateKilometer from './pages/Machinery/Kilometers/Create';
import Users from './pages/Admin/Users';
import ActivityLogs from './pages/Admin/ActivityLogs';
import UserPerformanceReport from './pages/Administration/UserPerformanceReport';
import ExchangeRates from './pages/Administration/ExchangeRates';
import Results from './pages/Administration/Reports/Results';
import Profile from './pages/Profile';
import Stock from './pages/Reports/Stock';
import InventoryDashboard from './pages/Reports/InventoryDashboard/Index';
import EntryChangeAlerts from './pages/Reports/EntryChangeAlerts';
import SupplyContinuousDocuments from './pages/SupplyContinuousDocuments/Index';
import ComprasDocumentRegister from './pages/Compras/Reports/DocumentRegister';
import ContabilidadComprasDiferenciadas from './pages/Contabilidad/Reports/ComprasDiferenciadas';
import ComprasPriceTracking from './pages/Compras/Reports/PriceTracking/Index';
import ComprasPriceTrackingAlerts from './pages/Compras/Reports/PriceTracking/Alerts';
import ComprasPriceTrackingSuppliers from './pages/Compras/Reports/PriceTracking/Suppliers';
import ComprasPriceTrackingProducts from './pages/Compras/Reports/PriceTracking/Products';
import ComprasPriceTrackingProductDetail from './pages/Compras/Reports/PriceTracking/ProductDetail';
import ComprasPriceTrackingHistory from './pages/Compras/Reports/PriceTracking/History';
import CreateSupplyContinuousDocument from './pages/SupplyContinuousDocuments/Create';
import SupplyContinuousDocumentDetail from './pages/SupplyContinuousDocuments/Detail';
import EditSupplyContinuousDocument from './pages/SupplyContinuousDocuments/Edit';
import ProduccionIndex from './pages/Produccion/Index';
import GuiasProduccionHub from './pages/Produccion/Guias/GuiasProduccionHub';
import GuiasProduccionList from './pages/Produccion/Guias/GuiasProduccionList';
import GuiasProduccionForm from './pages/Produccion/Guias/GuiasProduccionForm';
import GuiasProduccionAnalisis from './pages/Produccion/Guias/GuiasProduccionAnalisis';
import GuiasProduccionPrint from './pages/Produccion/Guias/GuiasProduccionPrint';
import ProduccionLineasIndex from './pages/Produccion/Lineas/Index';
import InsumoEnRecetas from './pages/Produccion/Reportes/InsumoEnRecetas';
import ProduccionDashboard from './pages/Produccion/Reportes/Dashboard';
import ProduccionConcesionariaIndex from './pages/ProduccionConcesionaria/Index';
import ProduccionConfiguracionIndex from './pages/ProduccionConcesionaria/Configuracion/Index';
import AlmacenesProductoTerminado from './pages/ProduccionConcesionaria/Configuracion/AlmacenesProductoTerminado';
import ClasificacionRecetasLayout from './pages/ProduccionConcesionaria/ClasificacionRecetas/ClasificacionRecetasLayout';
import RecetasCategories from './pages/ProduccionConcesionaria/ClasificacionRecetas/Categories';
import RecetasSubcategories from './pages/ProduccionConcesionaria/ClasificacionRecetas/Subcategories';
import RecetasFamilies from './pages/ProduccionConcesionaria/ClasificacionRecetas/Families';
import RecetasHierarchy from './pages/ProduccionConcesionaria/ClasificacionRecetas/Hierarchy';
import RecetasListado from './pages/ProduccionConcesionaria/ClasificacionRecetas/Recetas';
import RecetasForm from './pages/ProduccionConcesionaria/ClasificacionRecetas/RecetasForm';
import Mesas from './pages/Restaurantes/Configuracion/Mesas';
import Cocinas from './pages/Restaurantes/Configuracion/Cocinas';
import TiemposComida from './pages/ProduccionConcesionaria/TiemposComida';
import TipoPlato from './pages/ProduccionConcesionaria/TipoPlato';
import AreaDespacho from './pages/ProduccionConcesionaria/AreaDespacho';
import ConfigCuadroVentaProduccion from './pages/ProduccionConcesionaria/VentaProduccion/ConfigCuadro';
import ProduccionDiaCuadro from './pages/ProduccionConcesionaria/VentaProduccion/ProduccionDia';
import VentaProduccionDashboard from './pages/ProduccionConcesionaria/VentaProduccion/VentaProduccionDashboard';
import PlantillasCiclicos from './pages/ProduccionConcesionaria/Planeamiento/PlantillasCiclicos';
import CiclicosIndex from './pages/ProduccionConcesionaria/Planeamiento/CiclicosIndex';
import CiclicoNuevo from './pages/ProduccionConcesionaria/Planeamiento/CiclicoNuevo';
import CiclicoDetalle from './pages/ProduccionConcesionaria/Planeamiento/CiclicoDetalle';
import SalidasProduccionIndex from './pages/ProduccionConcesionaria/Operaciones/SalidasProduccionIndex';
import SalidasProduccionDetalle from './pages/ProduccionConcesionaria/Operaciones/SalidasProduccionDetalle';
import DespachoIndex from './pages/ProduccionConcesionaria/Operaciones/DespachoIndex';
import DespachoDetalle from './pages/ProduccionConcesionaria/Operaciones/DespachoDetalle';
import RestaurantesIndex from './pages/Restaurantes/Index';
import OperacionesIndex from './pages/Restaurantes/Operaciones/Index';
import Pedidos from './pages/Restaurantes/Operaciones/Pedidos';
import AccesoZonas from './pages/Restaurantes/Operaciones/AccesoZonas';
import AccesoMesas from './pages/Restaurantes/Operaciones/AccesoMesas';
import MesaDetalle from './pages/Restaurantes/Operaciones/MesaDetalle';
import EspacioProduccion from './pages/Restaurantes/Operaciones/EspacioProduccion';
import ActivosIndex from './pages/Activos/Index';
import ClasificacionActivosLayout from './pages/Activos/Clasificacion/ClasificacionActivosLayout';
import ActivosCategories from './pages/Activos/Clasificacion/Categories';
import ActivosSubcategories from './pages/Activos/Clasificacion/Subcategories';
import ActivosFamilies from './pages/Activos/Clasificacion/Families';
import ActivosHierarchy from './pages/Activos/Clasificacion/Hierarchy';
import ActivosListado from './pages/Activos/Listado/Index';
import CargarActivosIniciales from './pages/Activos/Listado/CargarIniciales';
import EditActivo from './pages/Activos/Listado/Edit';
import PrintActivo from './pages/Activos/Listado/Print';
import PrintActivoBarcode from './pages/Activos/Listado/PrintBarcode';
import ActivosEnUso from './pages/Activos/EnUso/Index';
import ActivosDepreciacion from './pages/Activos/Financiero/Depreciacion';
import ActivosAreas from './pages/Activos/Configuracion/Areas';
import SelectSalesPointOfSale from './pages/Ventas/SelectPointOfSale';
import SelectPurchaseSite from './pages/Compras/SelectPurchaseSite';
import PurchaseSiteAssignment from './pages/Compras/PurchaseSiteAssignment/Index';
import PurchaseSites from './pages/Configuration/PurchaseSites';
import ComprasPurchaseSiteGate from './components/Compras/ComprasPurchaseSiteGate';
import { ComprasPurchaseSiteProvider } from './contexts/ComprasPurchaseSiteContext';
import VentasClients from './pages/Ventas/Clients/Index';
import CreateVentasClient from './pages/Ventas/Clients/Create';
import EditVentasClient from './pages/Ventas/Clients/Edit';
import VentasPriceList from './pages/Ventas/PriceList/Index';
import VentasPosProjectConfig from './pages/Ventas/PosProjectConfig/Index';
import VentasPosSeriesConfig from './pages/Ventas/PosSeriesConfig/Index';
import VentasPosWarehouseConfig from './pages/Ventas/PosWarehouseConfig/Index';
import SalesSectionPlaceholder from './pages/Ventas/SalesSectionPlaceholder';
import VentasReportsIndex from './pages/Ventas/Reports/Index';
import VentasSalesDashboard from './pages/Ventas/Reports/SalesDashboard';
import VentasSalesRegister from './pages/Ventas/Reports/SalesRegister';
import VentasProductMarginsReport from './pages/Ventas/Reports/ProductMargins';
import VentasCashLiquidationsReport from './pages/Ventas/Reports/CashLiquidations';
import VentasCashLiquidationIndex, {
  VentasCashByShiftRedirect,
} from './pages/Ventas/CashLiquidation/Index';
import VentasQuotesIndex from './pages/Ventas/Quotes/Index';
import CreateVentasQuote from './pages/Ventas/Quotes/Create';
import EditVentasQuote from './pages/Ventas/Quotes/Edit';
import VentasServiceOrdersIndex from './pages/Ventas/ServiceOrders/Index';
import CreateVentasServiceOrder from './pages/Ventas/ServiceOrders/Create';
import EditVentasServiceOrder from './pages/Ventas/ServiceOrders/Edit';
import PrintVentasQuote from './pages/Ventas/Quotes/Print';
import PrintVentasServiceOrder from './pages/Ventas/ServiceOrders/Print';
import VentasOrdersIndex from './pages/Ventas/Orders/Index';
import CreateVentasOrder from './pages/Ventas/Orders/Create';
import EditVentasOrder from './pages/Ventas/Orders/Edit';
import VentasBulkImport from './pages/Ventas/Orders/BulkImport';
import VentasContinuousServicesIndex from './pages/Ventas/ContinuousServices/Index';
import CreateVentasContinuousService from './pages/Ventas/ContinuousServices/Create';
import VentasContinuousServiceDetail from './pages/Ventas/ContinuousServices/Detail';
import PrintVentasContinuousService from './pages/Ventas/ContinuousServices/Print';
import SalesPosGate from './components/Ventas/SalesPosGate';
import { SalesPointOfSaleProvider } from './contexts/SalesPointOfSaleContext';
import Layout from './components/Layout/Layout';
import ManualIndex from './pages/Manual/Index';
import { authService } from './services/authService';
import { canUserAccessContabilidad } from './utils/contabilidadAccess';

// Componente para proteger rutas
const ProtectedRoute = ({ children }) => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Redirige a dashboard si el módulo Maquinaria está deshabilitado
const MachineryGuard = () => {
  const { machineryEnabled, loaded } = useModuleSettings();
  const user = authService.getCurrentUser();
  const location = useLocation();
  if (!loaded) {
    return <Outlet />;
  }
  if (!machineryEnabled) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }
  if (user?.role === 'limitado' && !user?.module_access?.machinery) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }
  return <Outlet />;
};

/** Redirige rutas legacy de recetas bajo concesionaria al módulo Producción general. */
const LegacyRecetasConcesionariaRedirect = () => {
  const location = useLocation();
  const suffix = location.pathname.replace(/^\/produccion-concesionaria\/clasificacion-recetas/, '');
  return (
    <Navigate
      to={`/produccion/clasificacion-recetas${suffix || '/categorias'}${location.search}`}
      replace
    />
  );
};

const ProduccionGuard = () => {
  const { produccionEnabled, loaded } = useModuleSettings();
  const user = authService.getCurrentUser();
  const location = useLocation();
  if (!loaded) {
    return <Outlet />;
  }
  if (!produccionEnabled) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }
  if (user?.role === 'limitado') {
    const access = user?.module_access || {};
    if (!access.produccion && !access.produccion_concesionaria && !access.restaurantes) {
      return <Navigate to="/dashboard" replace state={{ from: location }} />;
    }
  }
  return <Outlet />;
};

const ProduccionConcesionariaGuard = () => {
  const {
    produccionConcesionariaEnabled,
    concesionariaVentaOperacionesEnabled,
    loaded,
  } = useModuleSettings();
  const user = authService.getCurrentUser();
  const location = useLocation();
  /** Mientras carga la API, el estado inicial es `false` y no debe redirigir al dashboard */
  if (!loaded) {
    return <Outlet />;
  }
  const sliceOn = concesionariaVentaOperacionesEnabled;
  const fullOn = produccionConcesionariaEnabled;
  if (!sliceOn && !fullOn) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }
  if (user?.role === 'limitado' && !user?.module_access?.produccion_concesionaria) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }
  return <Outlet />;
};

const RestaurantesGuard = () => {
  const { restaurantesEnabled, loaded } = useModuleSettings();
  const user = authService.getCurrentUser();
  const location = useLocation();
  if (!loaded) {
    return <Outlet />;
  }
  if (!restaurantesEnabled) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }
  if (user?.role === 'limitado' && !user?.module_access?.restaurantes) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }
  return <Outlet />;
};

const ActivosGuard = () => {
  const { activosEnabled, loaded } = useModuleSettings();
  const location = useLocation();
  if (!loaded) {
    return <Outlet />;
  }
  if (!activosEnabled) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }
  return <Outlet />;
};

const VentasGuard = () => {
  const { ventasEnabled, loaded } = useModuleSettings();
  const location = useLocation();
  if (!loaded) {
    return <Outlet />;
  }
  if (!ventasEnabled) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }
  return <Outlet />;
};

/** Redirige rutas legacy de clasificación bajo /activos/clasificacion. */
const LegacyActivosClasificacionRedirect = () => {
  const location = useLocation();
  const suffix = location.pathname.replace(/^\/activos\/clasificacion/, '');
  return (
    <Navigate
      to={`/activos/configuracion/clasificacion${suffix || '/categorias'}${location.search}`}
      replace
    />
  );
};

// Solo administradores pueden acceder
const AdminRoute = ({ children }) => {
  const user = authService.getCurrentUser();
  if (!user || user.role !== 'administrador') {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

// Contabilidad: super admin, contador o usuarios autorizados por el super admin
const ContabilidadRoute = ({ children }) => {
  const user = authService.getCurrentUser();
  if (!canUserAccessContabilidad(user)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

/** Gestión → Configuración (unidades, proyectos, etc.): no disponible para rol limitado. */
const ManagementConfigurationGuard = () => {
  const user = authService.getCurrentUser();
  const location = useLocation();
  if (user?.role === 'limitado' && location.pathname.startsWith('/configuration')) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
};

function App() {
  return (
    <BrowserRouter>
      <ModuleSettingsProvider>
      <ComprasPurchaseSiteProvider>
      <SalesPointOfSaleProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/requirements/:id/print"
          element={
            <ProtectedRoute>
              <PrintRequirement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase-orders/:id/print"
          element={
            <ProtectedRoute>
              <PrintPurchaseOrder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ventas/quotes/:id/print"
          element={
            <ProtectedRoute>
              <PrintVentasQuote />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ventas/continuous-services/:id/print"
          element={
            <ProtectedRoute>
              <PrintVentasContinuousService />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ventas/service-orders/:id/print"
          element={
            <ProtectedRoute>
              <PrintVentasServiceOrder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/service-orders/:id/print"
          element={
            <ProtectedRoute>
              <PrintServiceOrder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documents/:id/print"
          element={
            <ProtectedRoute>
              <PrintDocument />
            </ProtectedRoute>
          }
        />
        <Route
          path="/entry-guides/:id/print"
          element={
            <ProtectedRoute>
              <PrintEntryGuide />
            </ProtectedRoute>
          }
        />
        <Route
          path="/initial-guides/:id/print"
          element={
            <ProtectedRoute>
              <PrintInitialGuide />
            </ProtectedRoute>
          }
        />
        <Route
          path="/exit-guides/:id/print"
          element={
            <ProtectedRoute>
              <PrintExitGuide />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transfer-guides/:id/print"
          element={
            <ProtectedRoute>
              <PrintTransferGuide />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reception-guides/:id/print"
          element={
            <ProtectedRoute>
              <PrintReceptionGuide />
            </ProtectedRoute>
          }
        />
        <Route
          path="/continuous-services/:id/print"
          element={
            <ProtectedRoute>
              <PrintContinuousService />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activos/listado/:id/print"
          element={
            <ProtectedRoute>
              <PrintActivo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activos/listado/:id/print-barcode"
          element={
            <ProtectedRoute>
              <PrintActivoBarcode />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="manual" element={<ManualIndex />} />
          <Route path="manual/*" element={<ManualIndex />} />
          <Route path="classification" element={<ClassificationIndex />} />
          <Route path="classification/categories" element={<Categories />} />
          <Route path="classification/subcategories" element={<Subcategories />} />
          <Route path="classification/families" element={<Families />} />
          <Route path="classification/hierarchy" element={<Hierarchy />} />
          <Route path="classification/services" element={<ClasificacionServiciosLayout />}>
            <Route index element={<Navigate to="categories" replace />} />
            <Route path="categories" element={<ServicesCategories />} />
            <Route path="subcategories" element={<ServicesSubcategories />} />
            <Route path="families" element={<ServicesFamilies />} />
            <Route path="hierarchy" element={<ServicesHierarchy />} />
          </Route>
          <Route path="products" element={<Products />} />
          <Route path="products/create" element={<CreateProduct />} />
          <Route path="products/:id/edit" element={<EditProduct />} />
          <Route path="services" element={<Services />} />
          <Route path="services/create" element={<CreateService />} />
          <Route path="services/:id/edit" element={<EditService />} />
          <Route path="compras/select-site" element={<SelectPurchaseSite />} />
          <Route path="compras/purchase-site-assignment" element={<PurchaseSiteAssignment />} />
          <Route element={<ComprasPurchaseSiteGate />}>
            <Route path="requirements" element={<RequirementsIndex />} />
            <Route path="requirements/create" element={<CreateRequirement />} />
            <Route path="requirements/:id/edit" element={<EditRequirement />} />
            <Route path="purchase-orders" element={<PurchaseOrders />} />
            <Route path="purchase-orders/create" element={<CreatePurchaseOrder />} />
            <Route path="purchase-orders/:id/edit" element={<EditPurchaseOrder />} />
            <Route path="service-orders" element={<ServiceOrders />} />
            <Route path="service-orders/create" element={<CreateServiceOrder />} />
            <Route path="service-orders/:id/edit" element={<EditServiceOrder />} />
            <Route path="continuous-services" element={<ContinuousServices />} />
            <Route path="continuous-services/create" element={<CreateContinuousService />} />
            <Route path="continuous-services/:id" element={<ContinuousServiceDetail />} />
            <Route path="documents" element={<Documents />} />
            <Route path="documents/create" element={<CreateDocument />} />
            <Route path="documents/:id/edit" element={<EditDocument />} />
          </Route>
          <Route element={<ManagementConfigurationGuard />}>
            <Route path="configuration" element={<Configuration />} />
            <Route path="configuration/units" element={<Units />} />
            <Route path="configuration/conversions" element={<Conversions />} />
            <Route path="configuration/attributes" element={<Attributes />} />
            <Route path="configuration/warehouses" element={<Warehouses />} />
            <Route path="configuration/projects" element={<Projects />} />
            <Route path="configuration/areas" element={<Areas />} />
            <Route path="configuration/milestones" element={<Milestones />} />
            <Route path="configuration/document-number-series" element={<DocumentNumberSeries />} />
            <Route path="configuration/point-of-sales" element={<PointOfSales />} />
            <Route path="configuration/purchase-sites" element={<PurchaseSites />} />
          </Route>
          <Route path="suppliers" element={<Suppliers />} />
          <Route path="suppliers/create" element={<CreateSupplier />} />
          <Route path="suppliers/:id/edit" element={<EditSupplier />} />
          <Route path="entities" element={<Entities />} />
          <Route path="entities/create" element={<CreateEntity />} />
          <Route path="entities/:id/edit" element={<EditEntity />} />
          <Route path="sunat-mappings" element={<SunatMappings />} />
          <Route path="supply-continuous-documents" element={<SupplyContinuousDocuments />} />
          <Route path="supply-continuous-documents/create" element={<CreateSupplyContinuousDocument />} />
          <Route path="supply-continuous-documents/:id" element={<SupplyContinuousDocumentDetail />} />
          <Route path="supply-continuous-documents/:id/edit" element={<EditSupplyContinuousDocument />} />
          <Route path="compras/reports" element={<Navigate to="/compras/reports/document-register" replace />} />
          <Route path="compras/reports/document-register" element={<ComprasDocumentRegister />} />
          <Route path="compras/reports/price-tracking" element={<ComprasPriceTracking />} />
          <Route path="compras/reports/price-tracking/alerts" element={<ComprasPriceTrackingAlerts />} />
          <Route path="compras/reports/price-tracking/suppliers" element={<ComprasPriceTrackingSuppliers />} />
          <Route path="compras/reports/price-tracking/products" element={<ComprasPriceTrackingProducts />} />
          <Route path="compras/reports/price-tracking/products/:productId" element={<ComprasPriceTrackingProductDetail />} />
          <Route path="compras/reports/price-tracking/history" element={<ComprasPriceTrackingHistory />} />
          <Route
            path="contabilidad"
            element={<Navigate to="/contabilidad/reportes/compras-diferenciadas" replace />}
          />
          <Route
            path="contabilidad/reportes/compras-diferenciadas"
            element={
              <ContabilidadRoute>
                <ContabilidadComprasDiferenciadas />
              </ContabilidadRoute>
            }
          />
          <Route path="ventas" element={<VentasGuard />}>
            <Route index element={<Navigate to="/ventas/clients" replace />} />
            <Route path="select-pos" element={<SelectSalesPointOfSale />} />
            <Route path="clients" element={<VentasClients />} />
            <Route path="clients/create" element={<CreateVentasClient />} />
            <Route path="clients/:id/edit" element={<EditVentasClient />} />
            <Route path="price-list" element={<VentasPriceList />} />
            <Route path="pos-project-config" element={<VentasPosProjectConfig />} />
            <Route path="pos-series-config" element={<VentasPosSeriesConfig />} />
            <Route path="pos-warehouse-config" element={<VentasPosWarehouseConfig />} />
            <Route path="offers" element={<Navigate to="/ventas/price-list" replace state={{ tab: 'offers' }} />} />
            <Route path="reports" element={<VentasReportsIndex />} />
            <Route path="reports/ventas" element={<VentasSalesDashboard />} />
            <Route path="reports/registro" element={<VentasSalesRegister />} />
            <Route path="reports/productos" element={<VentasProductMarginsReport />} />
            <Route path="reports/liquidaciones-caja" element={<VentasCashLiquidationsReport />} />
            <Route path="reports/caja-turno" element={<VentasCashByShiftRedirect />} />
            <Route path="caja" element={<VentasCashLiquidationIndex />} />
            <Route element={<SalesPosGate />}>
              <Route path="quotes" element={<VentasQuotesIndex />} />
              <Route path="quotes/create" element={<CreateVentasQuote />} />
              <Route path="quotes/:id/edit" element={<EditVentasQuote />} />
              <Route path="service-orders" element={<VentasServiceOrdersIndex />} />
              <Route path="service-orders/create" element={<CreateVentasServiceOrder />} />
              <Route path="service-orders/:id/edit" element={<EditVentasServiceOrder />} />
              <Route path="orders" element={<VentasOrdersIndex />} />
              <Route path="orders/bulk-import" element={<VentasBulkImport />} />
              <Route path="orders/create" element={<CreateVentasOrder />} />
              <Route path="orders/:id/edit" element={<EditVentasOrder />} />
              <Route path="continuous-services" element={<VentasContinuousServicesIndex />} />
              <Route path="continuous-services/create" element={<CreateVentasContinuousService />} />
              <Route path="continuous-services/:id" element={<VentasContinuousServiceDetail />} />
              <Route path="documents" element={<SalesSectionPlaceholder title="Documentos de venta" description="Facturas, boletas y notas vinculadas a ventas." icon="🧾" />} />
            </Route>
          </Route>
          <Route path="warehouses" element={<SelectWarehouse />} />
          <Route path="warehouses/:id/documents" element={<WarehouseDocuments />} />
          <Route path="warehouses/:warehouseId/inventory-count" element={<WarehouseInventoryCount />} />
          <Route path="warehouses/:warehouseId/entry-guides/create" element={<CreateEntryGuide />} />
          <Route path="entry-guides/:id/edit" element={<EditEntryGuide />} />
          <Route path="warehouses/:warehouseId/initial-guides/create" element={<CreateInitialGuide />} />
          <Route path="initial-guides/:id/edit" element={<EditInitialGuide />} />
          <Route path="warehouses/:warehouseId/exit-guides/create" element={<CreateExitGuide />} />
          <Route path="exit-guides/:id/edit" element={<EditExitGuide />} />
          <Route path="warehouses/:warehouseId/transfer-guides/create" element={<CreateTransferGuide />} />
          <Route path="transfer-guides/:id/edit" element={<EditTransferGuide />} />
          <Route path="warehouses/:warehouseId/reception-guides/create" element={<CreateReceptionGuide />} />
          <Route path="reception-guides/:id/edit" element={<EditReceptionGuide />} />
          <Route path="warehouses/:warehouseId/adjustment-guides/create" element={<CreateAdjustmentGuide />} />
          <Route path="adjustment-guides/:id/edit" element={<EditAdjustmentGuide />} />
          <Route path="reports/kardex" element={<Kardex />} />
          <Route path="reports/inventory-dashboard" element={<InventoryDashboard />} />
          <Route path="reports/entry-change-alerts" element={<EntryChangeAlerts />} />
          <Route path="reports/kardex-inconsistencies" element={<KardexInconsistencies />} />
          <Route path="audit" element={<KardexAuditGuard />}>
            <Route path="kardex" element={<KardexAudit />} />
            <Route path="rules" element={<AuditRulesSettings />} />
            <Route path="inventory-count" element={<AuditInventoryCount />} />
            <Route path="inventory-count/:warehouseId" element={<AuditInventoryCount />} />
            <Route path="my-inventory-counts" element={<AuditMyInventoryCounts />} />
            <Route path="my-inventory-counts/:warehouseId/:campaignId" element={<AuditMyInventoryCounts />} />
            <Route path="recipients" element={<AuditNotificationRecipients />} />
          </Route>
          <Route path="reports/kardex/:productId/:warehouseId" element={<KardexDetail />} />
          <Route path="reports/kardex/:productId/:warehouseId/recalculate" element={<KardexRecalculate />} />
          <Route path="reports/entries-exits" element={<EntriesExits />} />
          <Route path="reports/entries-exits-matrix" element={<EntriesExitsMatrix />} />
          <Route path="reports/exits-by-supplier" element={<ExitsBySupplier />} />
          <Route path="reports/stock" element={<Stock />} />
          <Route path="administration/document-traceability" element={<DocumentTraceability />} />
          <Route path="administration/purchase-order-traceability" element={<PurchaseOrderTraceability />} />
          <Route path="administration/service-order-traceability" element={<ServiceOrderTraceability />} />
          <Route path="administration/entry-guide-traceability" element={<EntryGuideTraceability />} />
          <Route path="administration/requirement-traceability" element={<RequirementTraceability />} />
          <Route path="administration/reports/results" element={<Results />} />
          <Route path="machinery" element={<MachineryGuard />}>
            <Route path="machines" element={<Machines />} />
            <Route path="machines/create" element={<CreateMachine />} />
            <Route path="machines/:id/edit" element={<EditMachine />} />
            <Route path="vehicles" element={<Vehicles />} />
            <Route path="vehicles/create" element={<CreateVehicle />} />
            <Route path="vehicles/compliance" element={<VehicleComplianceAlerts />} />
            <Route path="vehicles/:id/edit" element={<EditVehicle />} />
            <Route path="categories" element={<MachineryCategories />} />
            <Route path="conductors" element={<Conductors />} />
            <Route path="conductors/create" element={<CreateConductor />} />
            <Route path="conductors/:id/edit" element={<EditConductor />} />
            <Route path="events" element={<EventsOverview />} />
            <Route path="events/lista" element={<Events />} />
            <Route path="events/config" element={<EventTypesConfig />} />
            <Route path="events/create" element={<CreateEvent />} />
            <Route path="events/:id/edit" element={<EditEvent />} />
            <Route path="maintenance" element={<Maintenance />} />
            <Route path="maintenance/history" element={<MaintenanceHistory />} />
            <Route path="reports" element={<MachineryReports />} />
            <Route path="maintenance/create" element={<Navigate to="/machinery/maintenance" replace />} />
            <Route path="maintenance/:id/edit" element={<Navigate to="/machinery/maintenance" replace />} />
            <Route path="hour-meters" element={<HourMeters />} />
            <Route path="hour-meters/create" element={<CreateHourMeter />} />
            <Route path="kilometers" element={<Kilometers />} />
            <Route path="kilometers/create" element={<CreateKilometer />} />
          </Route>
          <Route path="produccion" element={<ProduccionGuard />}>
            <Route index element={<ProduccionIndex />} />
            <Route path="guias" element={<GuiasProduccionHub />} />
            <Route path="guias/:tipoSlug" element={<GuiasProduccionList />} />
            <Route path="guias/:tipoSlug/nueva" element={<GuiasProduccionForm />} />
            <Route path="guias/:tipoSlug/editar/:id" element={<GuiasProduccionForm />} />
            <Route path="guias/:tipoSlug/analisis/:id" element={<GuiasProduccionAnalisis />} />
            <Route path="guias/:tipoSlug/imprimir/:id" element={<GuiasProduccionPrint />} />
            <Route path="lineas" element={<ProduccionLineasIndex />} />
            <Route path="reportes/dashboard" element={<ProduccionDashboard />} />
            <Route path="reportes/uso-insumo" element={<InsumoEnRecetas />} />
            <Route path="clasificacion-recetas" element={<ClasificacionRecetasLayout />}>
              <Route index element={<Navigate to="categorias" replace />} />
              <Route path="categorias" element={<RecetasCategories />} />
              <Route path="subcategorias" element={<RecetasSubcategories />} />
              <Route path="familias" element={<RecetasFamilies />} />
              <Route path="jerarquia" element={<RecetasHierarchy />} />
              <Route path="recetas/nueva" element={<RecetasForm />} />
              <Route path="recetas/editar/:id" element={<RecetasForm />} />
              <Route path="recetas" element={<RecetasListado />} />
            </Route>
          </Route>
          <Route path="produccion-concesionaria" element={<ProduccionConcesionariaGuard />}>
            <Route index element={<ProduccionConcesionariaIndex />} />
            <Route path="configuraciones" element={<ProduccionConfiguracionIndex />} />
            <Route path="configuraciones/almacenes-producto-terminado" element={<AlmacenesProductoTerminado />} />
            <Route path="configuraciones/tiempos" element={<TiemposComida />} />
            <Route path="configuraciones/tipo-plato" element={<TipoPlato />} />
            <Route path="configuraciones/area-despacho" element={<AreaDespacho />} />
            <Route path="configuraciones/cuadro-venta/:plantillaId" element={<ConfigCuadroVentaProduccion />} />
            <Route path="configuraciones/cuadro-venta" element={<ConfigCuadroVentaProduccion />} />
            <Route path="operaciones/produccion-dia/plantilla/:plantillaId/cuadro" element={<ProduccionDiaCuadro />} />
            <Route path="operaciones/produccion-dia/plantilla/:plantillaId" element={<ProduccionDiaCuadro />} />
            <Route path="operaciones/produccion-dia" element={<ProduccionDiaCuadro />} />
            <Route path="operaciones/venta-produccion-dashboard" element={<VentaProduccionDashboard />} />
            <Route path="clasificacion-recetas/*" element={<LegacyRecetasConcesionariaRedirect />} />
            <Route
              path="planeamiento"
              element={<Navigate to="/produccion-concesionaria/planeamiento/plantillas-ciclicos" replace />}
            />
            <Route path="planeamiento/plantillas-ciclicos" element={<PlantillasCiclicos />} />
            <Route path="planeamiento/ciclicos/nuevo" element={<CiclicoNuevo />} />
            <Route path="planeamiento/ciclicos/:id" element={<CiclicoDetalle />} />
            <Route path="planeamiento/ciclicos" element={<CiclicosIndex />} />
            <Route
              path="operaciones"
              element={<Navigate to="/produccion-concesionaria/operaciones/salidas-produccion" replace />}
            />
            <Route path="operaciones/salidas-produccion" element={<SalidasProduccionIndex />} />
            <Route
              path="operaciones/salidas-produccion/ciclo/:cicloId/dia/:diaKey"
              element={<SalidasProduccionDetalle />}
            />
            <Route path="operaciones/despacho" element={<DespachoIndex />} />
            <Route path="operaciones/despacho/ciclo/:cicloId/dia/:diaKey" element={<DespachoDetalle />} />
          </Route>
          <Route path="restaurantes" element={<RestaurantesGuard />}>
            <Route index element={<RestaurantesIndex />} />
            <Route path="clasificacion-recetas" element={<ClasificacionRecetasLayout />}>
              <Route index element={<Navigate to="categorias" replace />} />
              <Route path="categorias" element={<RecetasCategories />} />
              <Route path="subcategorias" element={<RecetasSubcategories />} />
              <Route path="familias" element={<RecetasFamilies />} />
              <Route path="jerarquia" element={<RecetasHierarchy />} />
              <Route path="recetas/nueva" element={<RecetasForm />} />
              <Route path="recetas/editar/:id" element={<RecetasForm />} />
              <Route path="recetas" element={<RecetasListado />} />
            </Route>
            <Route path="operaciones" element={<OperacionesIndex />} />
            <Route path="operaciones/pedidos" element={<Pedidos />} />
            <Route path="operaciones/acceso" element={<AccesoZonas />} />
            <Route path="operaciones/acceso/:zoneId" element={<AccesoMesas />} />
            <Route path="operaciones/mesa/:zoneId/:mesaId" element={<MesaDetalle />} />
            <Route path="operaciones/bar/:zoneId" element={<MesaDetalle />} />
            <Route path="operaciones/produccion" element={<EspacioProduccion />} />
            <Route path="configuraciones/mesas" element={<Mesas />} />
            <Route path="configuraciones/cocinas" element={<Cocinas />} />
          </Route>
          <Route path="activos" element={<ActivosGuard />}>
            <Route index element={<ActivosIndex />} />
            <Route path="listado" element={<ActivosListado />} />
            <Route path="en-uso" element={<ActivosEnUso />} />
            <Route path="financiero/depreciacion" element={<ActivosDepreciacion />} />
            <Route path="listado/cargar-iniciales" element={<CargarActivosIniciales />} />
            <Route path="listado/create" element={<Navigate to="/activos/listado/cargar-iniciales" replace />} />
            <Route path="listado/:id/edit" element={<EditActivo />} />
            <Route path="configuracion/clasificacion" element={<ClasificacionActivosLayout />}>
              <Route index element={<Navigate to="categorias" replace />} />
              <Route path="categorias" element={<ActivosCategories />} />
              <Route path="subcategorias" element={<ActivosSubcategories />} />
              <Route path="familias" element={<ActivosFamilies />} />
              <Route path="jerarquia" element={<ActivosHierarchy />} />
            </Route>
            <Route path="configuracion/areas" element={<ActivosAreas />} />
            <Route path="clasificacion/*" element={<LegacyActivosClasificacionRedirect />} />
          </Route>
          <Route path="admin/module-settings" element={<AdminRoute><ModuleSettings /></AdminRoute>} />
          <Route path="admin/general-settings" element={<AdminRoute><GeneralSettings /></AdminRoute>} />
          <Route path="admin/integration" element={<AdminRoute><IntegrationSettings /></AdminRoute>} />
          <Route path="admin/users" element={<AdminRoute><Users /></AdminRoute>} />
          <Route path="administration/activity-logs" element={<ActivityLogs />} />
          <Route path="administration/user-performance-report" element={<UserPerformanceReport />} />
          <Route path="administration/exchange-rates" element={<AdminRoute><ExchangeRates /></AdminRoute>} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
      </SalesPointOfSaleProvider>
      </ComprasPurchaseSiteProvider>
      </ModuleSettingsProvider>
    </BrowserRouter>
  );
}

export default App;
